export default import.meta.ROLLDOWN_FILE_URL_0rcgdt0vBdA4Bvm_4Ma0zw